<template>
  <div>
    <base-dialog
      :visible="visible"
      :show-close="false"
      :class="['dialog-wrap', { 'no-bar': fullScreen }]"
      border-radius="none"
      @open="open"
      @closed="closed"
    >
      <template v-slot:header>
        <div class="header-wrap" v-loading="loading">
          <div class="title">
            <div v-tip class="title-wrap">
              {{ taskInfo.milestone ? "[里程碑]" : taskInfo.riskSet ? "[风险]" : "[任务]"
              }}{{ taskInfo.name }}
            </div>
            <span class="icon-wrap">
              <span v-if="taskInfo.milestone" class="icon-milestone">
                <svg-icon icon-class="milestone"></svg-icon>
              </span>
              <span v-if="taskInfo.riskSet" class="icon-risk">
                <svg-icon icon-class="display_project-risk"></svg-icon>
              </span>
              <span
                v-if="projectInfo.publicMode && taskInfo.publicMode === false"
                class="icon-public-mode"
              >
                <span class="svg-container">
                  <svg-icon icon-class="public-mode" />
                </span>
                <span>隐私</span>
              </span>
              <template v-if="taskIds">
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="bottom"
                  :disabled="dataOrder === 'first'"
                >
                  <div slot="content">
                    上一条
                    <br />
                    快捷键(Alt ＋ ←)
                  </div>
                  <i
                    class="el-icon-arrow-left icon-trun-page"
                    :class="{ 'is-disabled': dataOrder == 'first' }"
                    @click="openData('previous')"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="bottom"
                  :disabled="dataOrder === 'last'"
                >
                  <div slot="content">
                    下一条
                    <br />
                    快捷键(Alt ＋ →)
                  </div>
                  <i
                    class="el-icon-arrow-right icon-trun-page"
                    :class="{ 'is-disabled': dataOrder == 'last' }"
                    @click="openData('later')"
                  ></i>
                </el-tooltip>
              </template>
            </span>
          </div>
          <div class="button-warp">
            <base-button
              v-for="(btn, index) in visibleBtnList.slice(0, 3)"
              :key="index"
              size="normal"
              :type="btn.id == 'COMPLETE' ? 'primary' : 'default'"
              @click="clickBtn(btn.id)"
            >
              {{ btn.name }}
            </base-button>
            <dropdown-menu
              v-if="btnMenuList.length > 0"
              @click="clickBtn"
              :menu-list="btnMenuList"
              placement="bottom-end"
            >
              <base-button size="normal" style="width: 32px; padding: 0">
                <i class="el-icon-more"></i>
              </base-button>
            </dropdown-menu>
          </div>
          <div class="operation-wrap">
            <span class="svg-icon" @click="init">
              <svg-icon icon-class="refresh" :class="rotate ? ' go' : ''"></svg-icon>
            </span>
            <span class="svg-icon" @click="closed">
              <svg-icon icon-class="close"></svg-icon>
            </span>
          </div>
        </div>
      </template>
      <div class="body-wrap" v-loading="loading">
        <verify-row
          :workflow-name="taskInfo.workflowName"
          :project-permission="projectPermission"
          ref="verifyRow"
          v-show="taskInfo.status === '待审核' && !project.template"
          :task-info="taskInfo"
          :sheet-def="sheetDef"
          @task-verified="taskVerified"
        ></verify-row>
        <div class="content-wrap">
          <div class="side-nav-wrap">
            <side-nav ref="sideMenu" :menu-list="tabs" @select="selectMenu"></side-nav>
          </div>
          <div v-ps class="content-box">
            <div class="content-title font-topic">
              {{ curTab.name }}
            </div>
            <div class="content-body" :style="{ overflow: curTab.cid ? 'hidden' : 'unset' }">
              <template v-if="curTab.name === '详细信息'">
                <data-detail
                  ref="dataDetail"
                  :task-info="taskInfo"
                  :sheet-def="sheetDef"
                ></data-detail>
              </template>
              <template v-else-if="curTab.name === '相关团队'">
                <data-team
                  @change="$emit('data-changed')"
                  :task-info="taskInfo"
                  :permission="curUserPermission"
                ></data-team>
              </template>
              <template v-else-if="curTab.name === '变更记录'">
                <data-log :task-id="taskId"></data-log>
              </template>
              <template v-else-if="curTab.name === '前置任务'">
                <div class="sheet-table-wrap" :class="{ 'full-screen': fullScreenPre }">
                  <div class="operation">
                    <div v-if="fullScreenPre" class="sheet-name font-topic">{{ curTab.name }}</div>
                    <div class="ref-button-group">
                      <span
                        v-if="curUserPermission['PREV_TASK']"
                        @click="$refs.selectPrevTaskDialog.open()"
                      >
                        +前置任务
                      </span>
                      <span @click="fullScreenPre = !fullScreenPre">
                        {{ fullScreenPre ? "退出全屏" : "全屏" }}
                      </span>
                    </div>
                  </div>
                  <task-table
                    key="preTaskTable"
                    ref="preTaskTable"
                    from="taskDetail"
                    :projectId="taskInfo.projectId"
                    :show-delete-btn="curUserPermission['PREV_TASK']"
                    :show-selection="false"
                    :show-pagination="false"
                    @delete-click="removePrevTask"
                  ></task-table>
                </div>
              </template>
              <template v-else>
                <div class="sheet-table-wrap" :class="{ 'full-screen': fullScreen }">
                  <div class="operation">
                    <div v-if="fullScreen" class="sheet-name font-topic">{{ curTab.name }}</div>
                    <div class="ref-button-group">
                      <span @click="subTaskDialogVisible = true">
                        +子任务
                      </span>
                      <span @click="fullScreen = !fullScreen">
                        {{ fullScreen ? "退出全屏" : "全屏" }}
                      </span>
                    </div>
                  </div>
                  <task-table
                    key="taskTable"
                    ref="taskTable"
                    from="taskDetail"
                    :projectId="taskInfo.projectId"
                    :show-pagination="false"
                  ></task-table>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </base-dialog>
    <!--编辑或复制-->
    <edit-dialog
      :projectId="taskInfo.projectId"
      :data-id="taskId"
      :task-group="taskInfo.taskGroup"
      :from="editDialogType"
      :visible.sync="editDialogVisible"
      :init-data="copyData"
      :is-risk="isRisk"
      :is-milestone="isMilestone"
      @after-submit="dataSubmitted"
    ></edit-dialog>
    <!--按钮填写-->
    <fill-dialog
      ref="fillDialog"
      from="fillForm"
      :task-id="taskId"
      :sheet-id="taskInfo.taskType.refSheetId"
      :data-id="taskInfo.sheetData.id"
      :raw-sheet-data="taskInfo.sheetData"
      :btn-info="{ fillCids: taskInfo.taskType.fillCids }"
      @after-submit="dataSubmitted"
      :project-info="projectInfo"
      :needDueReason="needDueReason"
      :needFill="needFill"
    ></fill-dialog>
    <due-reason-dialog
      ref="dueReasonDialog"
      :task-id="taskId"
      :sheet-id="taskInfo.taskType.refSheetId"
      :data-id="taskInfo.sheetData.id"
      :raw-sheet-data="taskInfo.sheetData"
      :project-info="projectInfo"
      @after-submit="dataSubmitted"
    ></due-reason-dialog>
    <!--子任务新建-->
    <edit-dialog
      from="create"
      :project-id="taskInfo.projectId"
      :task-group="taskInfo.taskGroup"
      :parent-task="taskInfo"
      :visible.sync="subTaskDialogVisible"
      @after-submit="afterCreateSubTask"
    ></edit-dialog>
    <!--移动任务分组-->
    <base-dialog :visible.sync="changeGroupVisible" show-close>
      <template v-slot:header>
        移动任务分组
      </template>
      <el-form>
        <el-form-item label="任务分组">
          <el-select v-model="targetGroupId" placeholder="请选择">
            <el-option
              v-for="item in taskGroupList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <base-button type="primary" @click="changeGroup">保存</base-button>
        <base-button @click="changeGroupVisible = false">取消</base-button>
      </template>
    </base-dialog>
    <!--选择前置任务-->
    <select-prev-task-dialog
      ref="selectPrevTaskDialog"
      :project-id="taskInfo.projectId"
      :task-id="taskId"
      @select="addPrevTask"
    ></select-prev-task-dialog>
    <change-parent-dialog
      ref="changeParentDialog"
      :project-id="taskInfo.projectId"
      :task-group="taskInfo.taskGroup"
      :selected-tasks="[taskInfo]"
      @select="changeParent"
    ></change-parent-dialog>
    <!--设置项目风险-->
    <set-risk-dialog ref="setRiskDialog" @submit="setRisk"></set-risk-dialog>
  </div>
</template>

<script>
import { basicBtnList } from "./static"
import VerifyRow from "@/components/Task/DetailDialog/VerifyRow"
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import EditDialog from "@/components/Task/EditDialog"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import SideNav from "@/components/Sheet/SideNav"
import DataLog from "./DataLog"
import DataTeam from "./DataTeam"
import FillDialog from "@/components/Task/FillDialog"
import DueReasonDialog from "@/components/Task/DueReasonDialog"
import DataDetail from "./DataDetail"
import {
  getTask,
  deleteTask,
  completeTask,
  redoTask,
  getTaskGroupList,
  changeTaskGroup,
  updatePrevTask,
  setTaskMilestone,
  setTaskPublicMode,
  changeTaskParent,
  setTaskRisk
} from "@/api/project/task"
import { permissionMap } from "@/utils/project"
import { getProjectPri, getTaskUserPermission } from "@/utils/checkPermission"
import ProvideCurProjectUsers from "@/mixins/provideCurProjectUsers"
import ProvideRootDepartment from "@/mixins/provideRootDepartment"
import { getProject } from "@/api/project/project"
import { getSheet } from "@/api/sheet/sheet"
import dj from "dayjs"
import SetRiskDialog from "@/components/Task/DetailDialog/setRiskDialog.vue"

export default {
  name: "detail-dialog",
  inject: {
    project: {
      default: () => ({ template: false })
    }
  },
  mixins: [ProvideCurProjectUsers, ProvideRootDepartment],
  components: {
    SetRiskDialog,
    BaseDialog,
    BaseButton,
    DropdownMenu,
    SideNav,
    DataDetail,
    DataTeam,
    DataLog,
    EditDialog,
    FillDialog,
    DueReasonDialog,
    VerifyRow
  },
  props: {
    taskId: {
      type: String,
      required: true
    },
    isMilestone: {
      type: Boolean,
      default: false
    },
    isRisk: {
      type: Boolean,
      default: false
    },
    visible: Boolean,
    taskIds: Array // 外部工作表当前页的 id 列表，用于切换上/下一条
  },
  beforeCreate() {
    this.$options.components.TaskTable = require("@/views/Front/Project/TaskList/TaskTable").default
    this.$options.components.EditDialog = require("@/components/Task/EditDialog").default
    this.$options.components.SelectPrevTaskDialog = require("@/components/Task/DetailDialog/SelectPrevTaskDialog").default
    this.$options.components.ChangeParentDialog = require("@/components/Task/DetailDialog/ChangeParentDialog").default
  },
  mounted() {
    this.$on("init", this.init)
  },
  data() {
    return {
      basicBtnList,
      taskInfo: {
        taskType: {},
        sheetData: {}
      },
      editDialogVisible: false,
      loading: false,
      subTaskDialogVisible: false,
      excelTemplateDialogVisible: false,
      curTab: { name: "详细信息" },
      // 按钮相关
      activeCustomBtn: {}, // 当前点击的自定义btn
      availableSheets: [],
      count: 0,
      fullScreenPre: false, // 前置任务全屏
      fullScreen: false, // 关联多条全屏
      editDialogType: "edit",
      copyData: null,
      projectPermission: {
        initial: true, // 用来表示这是初始对象,如果为真,则此人没有权限
        rolePris: {
          ASSIGNEE: {},
          CREATOR: {},
          PARTICIPANT: {}
        }
      },
      changeGroupVisible: false,
      targetGroupId: "",
      taskGroupList: [],
      projectInfo: {},
      sheetDef: {},
      rotate: false
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo
    },
    curUserPermission() {
      return getTaskUserPermission(this.projectPermission, this.taskInfo, this.curUser.userId)
    },
    needFill() {
      // 任务模版需要填写字段显示 填写并完成 按钮
      return Boolean(this.taskInfo?.taskType?.fillCids?.length > 0)
    },
    needDueReason() {
      return Boolean(
        this.projectInfo?.openDueReason &&
          dj(this.taskInfo.dueDate).isBefore(dj()) &&
          dj().diff(this.taskInfo.dueDate, "day")
      )
    },
    dataOrder() {
      if (!this.taskIds) return ""
      let index = this.taskIds.indexOf(this.taskId)
      if (index === 0) return "first"
      else if (index === this.taskIds.length - 1) return "last"
      return ""
    },
    tabs() {
      let arr = [{ name: "详细信息" }, { name: "前置任务" }]
      // 1. 当前任务深度过深,则不可编辑子任务
      // 2. 当前编辑任务的人,没有编辑子任务权限
      if (
        !(
          this.taskLevel >= 3 ||
          (this.from === "edit" && !this.curUserPermission["UPDATE_SUB_TASK"])
        )
      ) {
        arr.push({ name: `子任务（${this.taskInfo?.children?.length || 0}）` })
      }
      arr = arr.concat([{ name: "相关团队" }])
      if (!this.project.template) {
        arr = arr.concat([{ name: "变更记录" }])
      }
      return arr
    },
    visibleBtnList() {
      let allPris = Object.keys(permissionMap)
      return this.basicBtnList
        .map(btn => {
          if ((this.needFill || this.needDueReason) && btn.id === "COMPLETE") {
            btn = this._.cloneDeep(btn)
            btn.name = "填写并完成"
          }
          if (btn.id === "MILESTONE")
            btn.name = this.taskInfo.milestone ? "取消里程碑" : "标记为里程碑"
          if (btn.id === "RISK") btn.name = this.taskInfo.riskSet ? "取消风险" : "标记为风险"
          if (btn.id === "PRIVATE")
            btn.name = this.taskInfo.publicMode ? "设为隐私模式 " : "设为公开模式"
          return btn
        })
        .filter(btn => {
          // 按钮权限控制
          if (allPris.includes(btn.id) && !this.curUserPermission[btn.id]) return false
          // 按钮特定逻辑限制
          switch (btn.id) {
            case "REDO":
              if (this.project.template) return false
              if (this.taskInfo?.status !== "已完成") return false
              break
            case "COMPLETE":
              if (this.project.template) return false
              if (this.taskInfo?.status !== "待处理") return false
              break
            case "UPDATE":
              if (this.taskInfo?.status !== "待处理") return false
              break
            case "DELETE":
              if (this.taskInfo?.status !== "待处理") return false
              break
            case "PRIVATE":
              if (!this.projectInfo?.publicMode) return false
              break
            case "COPY":
              if (this.projectPermission.initial) return false
              break
            case "MILESTONE":
              if (this.taskInfo.riskSet) return false
              break
            case "RISK":
              if (this.taskInfo.milestone) return false
              break
          }
          return true
        })
    },
    btnMap() {
      return this._.keyBy(this.basicBtnList, "id")
    },
    btnMenuList() {
      return this.visibleBtnList.slice(3).map(btn => {
        return {
          title: btn.name,
          command: btn.id
        }
      })
    },
    // 任务层级数
    taskLevel() {
      let level = 1
      if (this.taskInfo.parentId) {
        ++level
        if (this.taskInfo.parentTask?.parentId) ++level
      }
      return level
    }
  },
  methods: {
    init() {
      this.rotate = !this.rotate
      setTimeout(() => {
        this.rotate = !this.rotate
      }, 1000)
      this.loading = true
      this.resetTab()
      this.getTask().then(() => {
        this.initDataDetail()
        this.$refs.verifyRow?.init()
        this.loading = false
      })
    },
    initDataDetail() {
      let component = this.$refs.dataDetail
      component && component.init()
    },
    open() {
      document.onkeydown = e => {
        let keyCode = e.keyCode || e.which || e.charCode
        let altKey = e.altKey
        if (altKey && keyCode === 37) {
          this.openData("previous")
        } else if (altKey && keyCode === 39) {
          this.openData("later")
        }
      }
      this.init()
    },
    closed() {
      document.onkeydown = undefined
      this.resetTab()
      this.$emit("update:visible", false)
    },
    taskVerified() {
      this.init()
      this.$emit("data-changed")
    },
    getTask() {
      return getTask(this.taskId).then(res => {
        res.sheetData = res.sheetData || {} // 防止数据初始化错误
        this.taskInfo = res
        this.$refs.taskTable?.init(res.children)
        this.$refs.preTaskTable?.init(res.prevTaskList)
        getProjectPri(this.taskInfo?.projectId)
          .then(userPermission => (this.projectPermission = userPermission))
          .catch(res => {
            // "查看下属负责的任务"功能,需要此人不在参与人中,也能看此任务
            // this.closed()
            // this.$message.error(res)
            // return Promise.reject(res)
          })
        getProject(this.taskInfo?.projectId).then(res => {
          this.projectInfo = res
        })
        getTaskGroupList(this.taskInfo?.projectId).then(taskGroupList => {
          this.taskGroupList = taskGroupList
        })
        this.refreshCurProjectUsers(this.taskInfo.projectId)
        if (this.taskInfo.taskType?.refSheetId) {
          return getSheet(this.taskInfo.taskType?.refSheetId).then(
            sheetDef => (this.sheetDef = sheetDef)
          )
        }
      })
    },
    selectMenu(menu) {
      this.curTab = menu
      if (menu.name === "详细信息") this.$nextTick(() => this.initDataDetail())
      else if (menu.name === "前置任务")
        this.$nextTick(() => this.$refs.preTaskTable.init(this.taskInfo.prevTaskList))
      else if (menu.name.startsWith("子任务"))
        this.$nextTick(() => this.$refs.taskTable.init(this.taskInfo.children))
    },
    dataSubmitted(from) {
      this.$emit("data-changed")
      if (from === "edit" || from) {
        this.closed()
      }
      // else if (from === "copy") {
      //   return
      // } else {
      //   this.init()
      // }
    },
    // 表格数据上下翻页
    openData(direction) {
      let taskId = ""
      let index = this.taskIds.indexOf(this.taskId)
      if (direction == "previous") {
        if (this.dataOrder !== "first") {
          taskId = this.taskIds[index - 1]
        } else {
          this.$message.info("已经是第一条数据")
        }
      } else if (direction == "later") {
        if (this.dataOrder !== "last") {
          taskId = this.taskIds[index + 1]
        } else {
          this.$message.info("已经是最后一条数据")
        }
      }
      if (!taskId) return
      this.$emit("trun-page", taskId)
    },
    async clickBtn(btnId) {
      try {
        switch (btnId) {
          case "UPDATE":
            this.editDialogType = "edit"
            this.editDialogVisible = true
            return
          case "DELETE":
            await this.deleteTask()
            break
          case "MILESTONE":
            this.loading = true
            await this.tabMilestone()
            break
          case "RISK":
            // 已经是风险就直接取消风险 否打开风险设置框并进行初始化
            if (this.taskInfo.riskSet === true) {
              await this.setRisk()
            } else {
              this.$refs.setRiskDialog.init(this.taskInfo)
            }
            return
          case "PRIVATE":
            this.loading = true
            await this.tabPublicMode()
            break
          case "REDO":
            this.loading = true
            await this.redoTask()
            break
          case "COMPLETE":
            await this.completeTask()
            break
          case "CHANGE_GROUP":
            this.changeGroupVisible = true
            return
          case "UPDATE_PARENT_ID":
            this.$refs.changeParentDialog.open()
            return
          case "COPY":
            this.editDialogType = "copy"
            this.handleCopyData()
            return
        }
      } catch (err) {
        this.loading = false
        return
      }
      this.$emit("data-changed")
      this.$message.success("操作成功")
      this.loading = false
    },
    // 初始化 tab 页信息
    resetTab() {
      this.$refs.sideMenu?.init()
      this.curTab = { name: "详细信息" }
    },
    // 标记为里程碑/取消里程碑
    tabMilestone() {
      return setTaskMilestone(this.taskId, !this.taskInfo.milestone).then(() => {
        this.$set(this.taskInfo, "milestone", !this.taskInfo.milestone)
      })
    },
    async setRisk(risk) {
      await setTaskRisk(
        this.taskId,
        risk?.riskSet || false,
        risk?.riskLevel || this.taskInfo?.riskLevel,
        risk?.copingPlan || this.taskInfo?.copingPlan,
        risk?.attachmentIds || this.taskInfo?.attachmentIds,
        risk?.description || this.taskInfo?.description
      ).then(() => {
        if (risk == undefined || risk == null) {
          this.$set(this.taskInfo, "riskSet", false)
        } else {
          this.$set(this.taskInfo, "riskSet", true)
          this.$refs.setRiskDialog.closed()
        }
        this.$message.success("操作成功")
        this.$emit("data-changed")
        this.closed()
      })
    },
    // 隐私模式
    tabPublicMode() {
      return setTaskPublicMode(this.taskId, !this.taskInfo.publicMode).then(() => {
        this.$set(this.taskInfo, "publicMode", !this.taskInfo.publicMode)
      })
    },
    // 复制当前数据
    handleCopyData() {
      this.copyData = this._.cloneDeep(this.taskInfo)
      this.editDialogVisible = true
      this.closed()
    },
    // 删除工作表数据
    deleteTask() {
      return new Promise((resolve, reject) => {
        this.$confirm("确认删除此任务?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            deleteTask([this.taskId]).then(() => {
              resolve()
              this.closed()
            })
          })
          .catch(err => {
            reject()
          })
      })
    },
    redoTask() {
      return redoTask(this.taskId).then(() => {
        this.closed()
      })
    },
    completeTask() {
      if (this.needFill) {
        this.$refs.fillDialog.open()
        // 目的是为了不让调用的地方刷新
        return Promise.reject()
      } else if (this.needDueReason) {
        this.$refs.dueReasonDialog.open()
        return Promise.reject()
      } else {
        this.loading = true
        return completeTask(this.taskId).then(() => {
          this.closed()
        })
      }
    },
    afterCreateSubTask() {
      this.init()
      this.$emit("data-changed")
    },
    changeGroup() {
      changeTaskGroup([this.taskId], this.targetGroupId).then(() => {
        this.targetGroupId = ""
        this.changeGroupVisible = false
        this.$message.success("操作成功")
        this.$emit("data-changed")
        this.closed()
      })
    },
    addPrevTask(task) {
      updatePrevTask(this.taskId, task.id, true).then(() => {
        this.init()
        this.$emit("data-changed")
      })
    },
    removePrevTask(task) {
      updatePrevTask(this.taskId, task.id, false).then(() => {
        this.init()
        this.$emit("data-changed")
      })
    },
    changeParent({ taskIds, selectedVal }) {
      this.loading = true
      changeTaskParent(taskIds, selectedVal.id).then(() => {
        this.init()
        this.$emit("data-changed")
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  &::-webkit-scrollbar-track-piece {
    background: #cccccc;
  }

  &::-webkit-scrollbar {
    height: 14px;
  }

  &::-webkit-scrollbar-thumb {
    background: #9e9e9e;
    border-radius: 20px;
  }

  ::v-deep .el-dialog {
    width: calc(100vw - 100px) !important;
    height: calc(100vh - 70px) !important;
    min-width: 1200px;
    color: $color-font-first;

    .header {
      padding: 0 !important;

      .header-wrap {
        flex: auto;
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 40px;
        border-bottom: 2px solid #f5f5f5;

        .title {
          white-space: nowrap;
          margin-right: auto;
          font-size: $font-size-title-first;
          width: 520px;
          .icon-wrap {
            margin-left: 5px;
          }
          .title-wrap {
            line-height: 25px;
            width: auto !important;
            max-width: 460px;
          }
          .icon-milestone,
          .icon-risk {
            font-size: 16px;
            color: $color-auxiliary;
          }
          .icon-public-mode {
            font-size: 12px;
            line-height: 12px;
            padding: 1px 3px;
            margin-left: 5px;
            display: inline-block;
            border-radius: 13px;
            border: 1px solid #c0c4cc;
            color: $color-font-second;
          }
          .icon-trun-page {
            font-size: 16px;
            padding: 3px;
            color: $color-font-second;
            font-weight: bold;
            cursor: pointer;
            &:hover {
              color: $color-main;
            }
            &:first-of-type {
              padding-right: 0;
            }
            &:last-of-type {
              padding-left: 0;
            }
            &.is-disabled {
              color: $color-font-third;
              cursor: not-allowed;
            }
          }
        }

        .button-warp {
          display: flex;

          & > * {
            margin-left: 8px;
          }
        }

        .operation-wrap {
          & > * {
            margin-left: 8px;
          }
          .svg-icon {
            font-size: 20px;
            color: #535c65;
            cursor: pointer;
          }
          .go {
            transform: rotate(360deg);
            transition: all 1s;
          }
        }
      }
    }

    .el-dialog__body {
      padding: 0 !important;
      margin: 0;
      flex: auto;
      display: flex;

      .body-wrap {
        flex: 1;
        display: flex;
        flex-flow: column;
        overflow: hidden;

        .overview-info {
          height: 70px;
          background: #f5f7fa;
          flex: 0 0 auto;
        }

        .content-wrap {
          position: relative;
          flex: 1;
          overflow: hidden;
          .side-nav-wrap {
            position: absolute;
            width: 16%;
            top: 0;
            bottom: 0;
            right: 0;
          }
          .content-box {
            display: flex;
            flex-flow: column;
            height: 100%;
            width: 84%;
            margin-right: 16%;
            position: relative;
            .content-title {
              margin: 26px 0 26px 56px;
              position: relative;
              line-height: 28px;

              &:before {
                content: "";
                position: absolute;
                left: -20px;
                width: 6px;
                height: 28px;
                border-radius: 4px;
                background-color: #1989fa;
              }
            }

            .content-body {
              display: flex;
              flex-flow: column;
              flex: auto;
              padding-left: 56px;
              .sheet-table-wrap {
                flex: 1;
                overflow: hidden;
                padding-right: 56px;
                display: flex;
                flex-flow: column;
                background-color: #fff;
                .task-table {
                  height: 100%;
                  flex: 1;
                }
                .operation {
                  display: flex;
                  margin-bottom: 6px;
                  position: relative;
                  z-index: 100;
                  .sheet-name {
                    margin-left: 20px;
                    position: relative;
                    line-height: 28px;
                    &:before {
                      content: "";
                      position: absolute;
                      left: -20px;
                      width: 6px;
                      height: 28px;
                      border-radius: 4px;
                      background-color: #1989fa;
                    }
                  }
                }
                .ref-button-group {
                  margin-left: auto;
                  span {
                    font-size: $font-size-main;
                    height: 28px;
                    line-height: 28px;
                    color: $color-main;
                    cursor: pointer;
                    &:hover {
                      color: #66b1ff;
                    }
                    & + span {
                      margin-left: 10px;
                    }
                  }
                }
                .sheet-table {
                  flex: auto;
                  overflow: hidden;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
